import axios from 'axios';

import http from '@/services/http.js';

const JIANYING_API = '/videoapi/jianying';

export const uploadJianyingJobImage = async ({
  blob,
  clientId,
  imageId,
  onObjectCleaned,
  onObjectKey,
  slotId,
  templateId,
}) => {
  const fileName = `manual-crop-${imageId}.jpg`;
  const contentType = blob.type || 'image/jpeg';
  const signingResponse = await http.post(`${JIANYING_API}/jobs/image/upload-url`, {
    client_id: clientId,
    jianying_template_id: templateId,
    slot_id: slotId,
    file_name: fileName,
    content_type: contentType,
    file_size: blob.size,
  });
  const signed = signingResponse.data.data;
  onObjectKey?.(signed.object_key);
  try {
    await axios.put(signed.uploadUrl || signed.upload_url, blob, {
      headers: signed.headers,
    });
  } catch (error) {
    await cleanupJianyingJobImages({
      clientId,
      objectKeys: [signed.object_key],
    }).then(() => onObjectCleaned?.(signed.object_key)).catch(() => {});
    throw error;
  }
  return {
    kind: 'image',
    image_id: imageId,
    source: 'manual',
    object_key: signed.object_key,
  };
};

export const cleanupJianyingJobImages = async ({ clientId, objectKeys }) => {
  const keys = [...new Set(objectKeys || [])].filter(Boolean);
  if (!clientId || keys.length === 0) return { deleted: [], retained: [] };
  const results = [];
  for (let offset = 0; offset < keys.length; offset += 100) {
    const response = await http.post(`${JIANYING_API}/jobs/image/cleanup`, {
      client_id: clientId,
      object_keys: keys.slice(offset, offset + 100),
    });
    results.push(response.data.data);
  }
  return {
    deleted: results.flatMap((result) => result?.deleted || []),
    retained: results.flatMap((result) => result?.retained || []),
  };
};
